import { useLocalizationLabel } from '~/libraries/i18n/useLocalizationLabel';

export function useWorkflowTranslations() {
	const { t } = useLocalizationLabel();

	const getTitle = (workflowName: string): string => {
		return t(workflowName + '.TITLE');
	};

	const getDescription = (workflowName: string): string => {
		return t(workflowName + '.DESCRIPTION');
	};

	return {
		getTitle,
		getDescription
	};
}
